module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"error-detail-title":"Détail de l\u0027erreur","detail-button-label":"Détail","error-snackbar-message":"Une erreur est survenue"},"de":{}}')
  delete Component.options._Ctor
}
